import { render } from "./StatusPill.vue?vue&type=template&id=7f20065b&scoped=true"
import script from "./StatusPill.vue?vue&type=script&lang=js"
export * from "./StatusPill.vue?vue&type=script&lang=js"

import "./StatusPill.vue?vue&type=style&index=0&id=7f20065b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f20065b"]])

export default __exports__